import React from 'react'
import DefaultLeadsPage from '../../components/LeadsDataWithFilter'

function index() {
  return (
    <DefaultLeadsPage leadType="Ampere" />
  )
}

export default index